module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.b7f6a750.svg";